import { createAction } from '@reduxjs/toolkit'
import type { SlideState } from '../slide/types'
import type { LocalLayer } from '../layer/types'
import type { Update } from '@reduxjs/toolkit'

/**
 * Shared actions dispatched by thunks, handled by multiple slices via extraReducers.
 */

/** Full reset: new story loaded or different story selected */
export const editorInitialized = createAction<{
  storyId: number
  storyTitle?: string
  slides: SlideState[]
  layers: LocalLayer[]
}>('editor/initialized')

/** Incremental merge: same story refetched from server */
export const editorMerged = createAction<{
  newSlides: SlideState[]
  addedLayers: LocalLayer[]
  updatedCurrentLayers: Update<LocalLayer>[]
  updatedOriginalLayers: LocalLayer[]
  removedLayerIds: number[]
}>('editor/merged')

/** Clear all editor state */
export const editorCleared = createAction('editor/cleared')

/** Sync completed for a slide — server response replaces local state */
export const slideSyncFulfilled = createAction<{
  slideId: number
  layers: LocalLayer[]
}>('editor/slideSyncFulfilled')

/** Sync started */
export const slideSyncPending = createAction('editor/slideSyncPending')

/** Sync failed */
export const slideSyncRejected = createAction<{ error: string }>('editor/slideSyncRejected')

/** Reset a single slide to its original state */
export const slideReset = createAction<{ slideId: number }>('editor/slideReset')

/** Reset all slides to their original state */
export const allChangesReset = createAction('editor/allChangesReset')
